import * as React from 'react';
import { connect } from 'react-redux';
import { postToController } from '../../../../actions/apiActions';
import { handleNextStep, setStep, setQuoteData } from '../../../../actions/salesActions';
import KPSelectableList from '../../../BaseTemplate/SSPCustomComponentLibrary/KPSelectableList/KPSelectableList'
import { ISelectableListItem } from '../../../../interfaces/KPSelectableList/KPSelectableListInterfaces';
import './Address.css';

class AddressSelect extends React.PureComponent<any, any> {
    selectableListComponent: React.RefObject<KPSelectableList>;

    constructor(props: any) {
        super(props);

        this.state = {
            addressList: [],
            selectedAddress: this.props.sales.addressId,
            addressDescription: this.props.sales.address,
            submitted: false,
            nextDisabled: false
        };

        this.selectableListComponent = React.createRef();
        this.checkSubmit = this.checkSubmit.bind(this);
        this.getAddressList = this.getAddressList.bind(this);
        this.handleItemSelect = this.handleItemSelect.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.handleAddAddress = this.handleAddAddress.bind(this);
    }

    async componentDidMount() {
        let dataSet = await this.getAddressList();
        if (dataSet.length === 0) {
            this.handleAddAddress();
        }
        if (this.selectableListComponent?.current != null) {
            this.selectableListComponent.current.setList(dataSet);
        }
        this.setState({ addressList: dataSet });
        this.checkSubmit();
    }

    checkSubmit() {
        let valid = (this.state.selectedAddress !== null);
        this.setState({ nextDisabled: !valid });
    }

    async getAddressList() {
        let dataSet: ISelectableListItem[] = [];
        dataSet = this.props.sales.addresses?.map(item => {
            return ({
                id: item.id,
                value: item.id,
                label: item.description,
                selected: (this.props.sales.addressId === item.id),
            }) as ISelectableListItem;
        });
        return dataSet ?? [];
    }

    handleItemSelect(id: string, selected: boolean) {
        let item = this.state.addressList?.filter(x => x.id === id)[0];
        this.setState({ selectedAddress: id, addressDescription: item?.label }, () => this.checkSubmit());
    }

    handleAddAddress() {
        this.props.dispatchAction(setQuoteData({ addressId: null }));
        this.props.dispatchAction(handleNextStep());
    }

    async handleNextStep() {
        if (!this.state.nextDisabled) {
            this.props.dispatchAction(setQuoteData({ addressId: this.state.selectedAddress, address: this.state.addressDescription, addressDetail: { province: null, city: null, suburb: null, postalCode: null, formatted: null } }));
            this.props.dispatchAction(setStep(4, 1));
        }
    }

    public render() {
        return (
            <div className="container">
                <div className="step-instructions text-center mt-4">
                    What’s the address of the property being insured?
                </div>

                <div className="row mt-4">
                    <div className="col-md-8 offset-md-2 text-left">
                        <KPSelectableList
                            ref={this.selectableListComponent}
                            items={this.state.addressList}
                            handleSelect={this.handleItemSelect}
                            radioGroup={true}
                            autosize={true}
                        />
                    </div>
                </div>
                
                <div className="row mt-4">
                    <div className="col-md-8 offset-md-2">
                        <div className="row">
                            <div className="col-md-6 text-right mt-4">
                                <button type="button" className="btn btn-outline-red btnNavigate" onClick={this.handleAddAddress}>Add new address</button>
                            </div>

                            <div className="col-md-6 text-left mt-4">
                                <button type="button" className="btn btn-solid-red btnNavigate" disabled={this.state.nextDisabled} onClick={this.handleNextStep}>Next</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddressSelect);